export default "<div id=\"content\">\n    <app-notifications></app-notifications>\n</div>\n"